// extracted by mini-css-extract-plugin
module.exports = {"formLogin":"FormLogin_formLogin_3E5iN","isStyleDingBeauty":"FormLogin_isStyleDingBeauty_oL_h5","formVerifycode":"FormLogin_formVerifycode_2cbtD"};